var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Question"},[_c('div',{staticClass:"title fs20"},[_vm._v(_vm._s(_vm.problem.question))]),_c('div',{staticClass:"answer"},[_vm._v(_vm._s(_vm.problem.answer))])])}
var staticRenderFns = []

export { render, staticRenderFns }